module.exports = __webpack_public_path__ + "img/logo.3505387a.png";